import Konva from 'konva';
import { template } from 'underscore';
import React, { useEffect } from 'react';

export const mmToPx = (mm, dpi = 72) => {
  // делим на 25,4 - получаем дюймы, умножаем на dpi - получаем пиксели
  return (mm / 25.4) * dpi;
};

export const makeFieldText = (field, visitor) => {
  if (field.type === 'textarea') {
    return field.text;
  }
  let text = field.text;

  try {
    text = template(field.text)(visitor);
  } catch (e) {
    console.log(e);
  }
  if (field.allCaps) {
    text = text.toUpperCase();
  } else if (field.firstCaps) {
    text = text
      .split(' ')
      .map(e => e.charAt(0).toUpperCase() + e.slice(1))
      .join(' ');
  }

  return text;
};

export const fieldFontStyle = field => `${field.bold ? 'bold' : ''} ${field.italics ? 'italic' : ''}`;

// Подбираем размер той же Konva, которая потом рисует поле (с тем же начертанием и
// переносами): свой подсчёт строк расходился с её раскладкой, и последние строки
// молча отбрасывались на превью, а в PDF налезали на соседние поля.
const wordCount = str => str.split(/\s+/).filter(Boolean).length;

export const fitTextOnCanvas = (text, field) => {
  if (!field.adjustSize) return field.fontSize;

  const probe = new Konva.Text({
    text: text,
    width: field.size.x,
    fontFamily: field.font,
    fontStyle: fieldFontStyle(field),
  });

  const paragraphs = text.split('\n').length;
  const words = wordCount(text);

  let fontSize = parseInt(field.fontSize);
  for (; fontSize > 1; fontSize--) {
    probe.fontSize(fontSize);
    // При заданной ширине Konva режет не влезающее слово по буквам при любом wrap —
    // такой разрыв не считаем «влезло», иначе хвост слова уходит на строку, которая
    // не помещается по высоте, и буквы пропадают. Без переноса — только исходные строки.
    const lines = probe.textArr;
    const wordsKept = wordCount(lines.map(line => line.text).join(' ')) === words;
    const wrapOk = field.allowWrap ? wordsKept : lines.length === paragraphs;
    if (wrapOk && probe.height() <= field.size.y) {
      break;
    }
  }
  probe.destroy();
  return fontSize;
};

export const loadImage = (src, callback) => {
  let image = new Image();
  image.onload = function () {
    callback(image);
  };
  image.src = src;
};

export const calcPoints = (x, y, width, height, rotation = 0, useOffset = false) => {
  const newRotation = Konva.getAngle(rotation);

  if (useOffset) {
    x = x - ((width / 2) * Math.cos(newRotation) + (height / 2) * Math.sin(-newRotation));
    y = y - ((height / 2) * Math.cos(newRotation) + (width / 2) * Math.sin(newRotation));
  }

  return [
    x,
    y,
    x + width * Math.cos(newRotation),
    y + width * Math.sin(newRotation),
    x + width * Math.cos(newRotation) + height * Math.cos(newRotation + Math.PI / 2),
    y + width * Math.sin(newRotation) + height * Math.sin(newRotation + Math.PI / 2),
    x + height * Math.cos(newRotation + Math.PI / 2),
    y + height * Math.sin(newRotation + Math.PI / 2),
    x,
    y,
  ];
};

export function usePrevious(value) {
  const ref = React.useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}

export const useCompare = val => {
  const prevVal = usePrevious(val);
  return prevVal !== val;
};
